import config from 'config'

export interface SandboxVariant {
    prNumber: string
    label: string
    url: string
    author: string
    deployedAt: string
}

export async function fetchSandboxVariants(): Promise<SandboxVariant[]> {
    try {
        // Authenticated same-origin-to-the-LOS proxy (PLAT-1073) - the registry
        // itself has no public route, so this is the only way to read variant
        // metadata. credentials: 'include' sends the LOS session cookie, same
        // as the sessions/key fetch in useLosVersion.ts.
        const response = await fetch(
            `${config.API_BASE_URL}/api/v3/sandbox-variants/`,
            {
                credentials: 'include',
                signal: AbortSignal.timeout(3000),
            },
        )

        if (!response.ok) {
            // eslint-disable-next-line no-console
            console.error(
                `[sandbox-variants] registry unavailable (HTTP ${response.status}) — variant selector may be incomplete`,
            )

            return []
        }

        const data = await response.json()

        return data.variants ?? []
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(
            '[sandbox-variants] failed to reach variant registry:',
            err,
        )

        return []
    }
}
